/* eslint-disable no-unused-vars */
import React from 'react';
import { Outlet } from "react-router-dom";
import { Drawer, AppBar, Toolbar, IconButton, Typography, Box, useTheme, useMediaQuery, List, Divider } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { INestableMenuItemProps, NestableMenuItem } from "components/generic/NestableMenuItem";


const drawerWidth = 240;

const drawerItemsOtherLists: INestableMenuItemProps[] = [
  { name: 'Best Game Music', link: '/OtherList/Music' },
  { name: 'Best Game Songs', link: '/OtherList/Songs' },
  { name: 'Best Moment Or Sequence', link: '/OtherList/MomentOrSequence' },
  { name: 'Best Series', link: '/OtherList/Series' },
  { name: 'Zelda', link: '/OtherList/Zelda' },
  { name: 'Metroidvania', link: '/OtherList/Metroidvania' },
  { name: "Games I didn't finish", link: '/OtherList/GamesIDidntFinish' },
  { name: 'Top 5 songs of all time', link: '/OtherList/Top5Songs' },
];

const drawerItemsMain: INestableMenuItemProps[] = [
  {
    name: 'Greatest Games',
    link: '/',
  },
  {
    name: 'Yearly Top',
    link: '/YearlyList/2026',
    items: [
      { name: '2026', link: '/YearlyList/2026' },
      { name: '2025', link: '/YearlyList/2025' },
      { name: '2024', link: '/YearlyList/2024' },
      { name: '2023', link: '/YearlyList/2023' },
      { name: '2022', link: '/YearlyList/2022' },
      { name: '2021', link: '/YearlyList/2021' },
      { name: '2020', link: '/YearlyList/2020' },
      { name: '2019', link: '/YearlyList/2019' },
      { name: '2018', link: '/YearlyList/2018' },
      { name: '2017', link: '/YearlyList/2017' },
    ]
  },
  {
    name: 'Other Lists',
    link: '',
    items: drawerItemsOtherLists,
  }
];
const drawerItemsGwen: INestableMenuItemProps[] = [
  {
    name: "Gwen's List",
    link: '/GwenFullList',
  },
  {
    name: "Gwen's Years",
    link: '/GwenGOTYList/2025',
    items: [
      { name: '2025', link: '/GwenGOTYList/2025' },
      { name: '2024', link: '/GwenGOTYList/2024' },
      { name: '2023', link: '/GwenGOTYList/2023' },
    ]
  }
];


export default function Root() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };


  const drawerContent = (
    <>
      <List>
        {drawerItemsMain.map((item, index) => (
          <NestableMenuItem {...item} key={index} />
        ))}
      </List>
      <Divider sx={{ my: 1.5, borderBottomWidth: 4, borderColor: 'primary.main' }} />
      <List>
        {drawerItemsGwen.map((item, index) => (
          <NestableMenuItem {...item} key={index} />
        ))}
      </List>
    </>
  );

  return (
    <Box sx={{ display: 'flex' }}>
      {/* AppBar with hamburger menu for mobile */}
      <AppBar position="fixed" sx={{ zIndex: theme.zIndex.drawer + 1 }}>
        <Toolbar>
          {isMobile && (
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{ mr: 2 }}
            >
              <MenuIcon />
            </IconButton>
          )}
          <Typography variant="h6" noWrap component="div">
            A Frickin' Website
          </Typography>
        </Toolbar>
      </AppBar>
      {/* Drawer for desktop and mobile */}
      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="navigation menu"
      >
        <Drawer
          variant={isMobile ? "temporary" : "permanent"}
          open={isMobile ? mobileOpen : true}
          onClose={handleDrawerToggle}
          ModalProps={{ keepMounted: true }}
          sx={{
            display: { xs: 'block', sm: 'block' },
            '& .MuiDrawer-paper': {
              width: drawerWidth,
              boxSizing: 'border-box',
              marginTop: { xs: '56px', sm: '64px' },
              overflowY: 'auto',
              maxHeight: { xs: 'calc(100vh - 56px)', sm: 'calc(100vh - 64px)' },
            },
          }}
        >
          {drawerContent}
        </Drawer>
      </Box>
      {/* Main content */}
      <Box component="main" sx={{ flexGrow: 1, p: 3, mt: 8 }}>
        <Outlet />
      </Box>
    </Box>
  );
}